module.exports = __webpack_public_path__ + "img/10000.eb620a42.png";